import { T } from "services/lang/LanguageService";
import { ReportOptions } from "models/component-print-models";
import {
  DashboardComponentPropsBase,
  IComponentTimed,
} from "components/pages/dashboard/components/interfaces";
import { DatasetLoadingConf } from "../charts/interfaces";
import { IComponentTheme, IDateRange } from "../product-template-table/utils/interfaces";

export interface ValueChangeIndicatorProps
  extends DashboardComponentPropsBase<ReportOptions>,
    IDateRange,
    IComponentTimed,
    IComponentTheme {
  datasets: string[];
  title: string;
  subtitle: string;
  dataDisplayType: DataDisplayType;
  aggregationPeriod?: AggregationPeriod;
  displayLastValueDiff: boolean;
  diffType: DiffType;
  updateFrequency?: number;
  diffValueDecimalPlaces?: number;
  useDiffIndicatorColors?: boolean;
  highlightValue?: boolean;
  loadConf: DatasetLoadingConf;
  displayInline?: boolean;
  width?: number;
  hideUnit?: boolean;
  decimalPlaces?: number;
  upToUnit?: AggregationPeriod;
  useDataUpToLastFinishedMonth?: boolean;
}

export enum AggregationPeriod {
  MINUTES = "MINUTES",
  HOURS = "HOURS",
  DAYS = "DAYS",
  WEEKS = "WEEKS",
  MONTHS = "MONTHS",
  YEARS = "YEARS",
}

export const aggregationPeriodOptions = [
  { label: T("time.minutes"), value: AggregationPeriod.MINUTES },
  { label: T("time.hours"), value: AggregationPeriod.HOURS },
  { label: T("time.days"), value: AggregationPeriod.DAYS },
  { label: T("time.weeks"), value: AggregationPeriod.WEEKS },
  { label: T("time.months"), value: AggregationPeriod.MONTHS },
  { label: T("time.years"), value: AggregationPeriod.YEARS },
];

export enum DataDisplayType {
  LAST_VALUE = "Last Value",
  AVERAGE_VALUE = "Average Value",
  HORIZONTAL_BAR_CHART = "Horizontal Bar Chart",
}

export const dataDisplayTypeOptions = [
  { label: T("label.last-value"), value: DataDisplayType.LAST_VALUE },
  { label: T("label.average-value"), value: DataDisplayType.AVERAGE_VALUE },
  { label: T("label.horizontal-bar-chart"), value: DataDisplayType.HORIZONTAL_BAR_CHART },
];

export enum DiffType {
  ABSOLUTE = "absolute",
  PERCENTAGE = "percentage",
}

export const diffTypeOptions = [
  { label: T("word.absolute"), value: DiffType.ABSOLUTE },
  { label: T("word.percentage"), value: DiffType.PERCENTAGE },
];

export interface DiffValueOptions {
  value: number;
  currentValueInfo: React.ReactNode;
  previousValueInfo: React.ReactNode;
  isHorizontalBarChartDiffLoaded?: boolean;
}
